import { useQuery } from '@tanstack/react-query';
import { fetchUsers } from '../services/adminApi';

interface UseUsersFilters {
  search?: string;
  role?: string;
  status?: string;
  page?: number;
  limit?: number;
}

export function useUsers(filters: UseUsersFilters = {}) {
  return useQuery({
    queryKey: ['admin-users', filters],
    queryFn: () => fetchUsers(filters),
    staleTime: 30000,
  });
}
